import { FEATURE_FLAGS } from '../../../../featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../../helper/URLHelper';

import AuditLogsHome from './Index.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.AUDIT_LOGS,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/audit-logs'),
      meta,
      redirect: to => {
        return { name: 'auditlogs_list', params: to.params };
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/audit-logs/list'),
      name: 'auditlogs_list',
      meta,
      component: AuditLogsHome,
    },
  ],
};
